import { atom } from 'jotai';

// used to check if a date can be displayed on a server rendered page
export const isDateVisibleAtom = atom(false);
